module.exports = __webpack_public_path__ + "img/navbar_hoverMenu_1_1.3f200d7c.png";